module.exports = __webpack_public_path__ + "static/media/html.90755f2c.svg";